import { usePendingRequestsWatcher } from "../hooks/usePendingRequestsWatcher";

const PendingRequestsWatcher = () => {
    usePendingRequestsWatcher();
    return null;
};

export default PendingRequestsWatcher;

